var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22.5 25.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    x: -3.75,
    y: -2.5,
    width: 30,
    height: 30,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.75,
    y: -2.5,
    width: 30,
    height: 30,
    fill: "#d9d9d9"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.375,25.375l-2.875-2.875H2.5c-.688,0-1.276-.245-1.766-.734-.489-.49-.734-1.079-.734-1.766V2.5c0-.688.245-1.276.734-1.766.49-.489,1.079-.734,1.766-.734h17.5c.688,0,1.276.245,1.766.734.489.49.734,1.079.734,1.766v17.5c0,.688-.245,1.276-.734,1.766-.49.489-1.079.734-1.766.734h-5l-2.875,2.875c-.25.25-.542.375-.875.375s-.625-.125-.875-.375Zm-7.875-5.375h6l2.75,2.75,2.75-2.75h6V2.5H2.5v17.5Zm10.688-6.812l3.031-1.375c.25-.104.375-.292.375-.562s-.125-.458-.375-.562l-3.031-1.375-1.375-3.031c-.104-.25-.292-.375-.562-.375s-.458.125-.562.375l-1.375,3.031-3.031,1.375c-.25.104-.375.292-.375.562s.125.458.375.562l3.031,1.375,1.375,3.031c.104.25.292.375.562.375s.458-.125.562-.375l1.375-3.031Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistant);
export default __webpack_public_path__ + "static/media/Assistant.51bf9505b9badc5ef5c0b294b5f46e39.svg";
export { ForwardRef as ReactComponent };